module.exports={select:"Vælg",selected:"Valgt"};